export default "__VITE_PUBLIC_ASSET__e87ae804__"